module.exports = __webpack_public_path__ + "static/media/bkg-desserts.f70a18fd.jpg";